import type {
  BuyerProductGetResponseType,
  DiscoveryV2ListResponseType,
} from "@sellar-io/api-v2/types";
import type { BasketOrderItem } from "../../../../hooks";

const buildOrderItemFromDiscoveryProduct = (
  product: DiscoveryV2ListResponseType[number],
  fullProduct: BuyerProductGetResponseType,
): BasketOrderItem | null => {
  const childProduct = fullProduct.Products.find(
    (item) => item.id === product.id,
  );
  if (!childProduct?.ProductPriceTier) return null;

  const productPriceTier = childProduct.ProductPriceTier;
  const parentProduct = fullProduct.Parent;

  return {
    id: undefined,
    ProductId: childProduct.id,
    quantity: 1,
    price: productPriceTier.price,
    fullPrice: productPriceTier.fullPrice,
    discountable: productPriceTier.discountable,
    promotionAppliedAt: null,
    PromotionRewardItemId: null,
    Product: {
      id: childProduct.id,
      name: childProduct.name,
      type: childProduct.type,
      sku: childProduct.sku,
      unit: childProduct.unit,
      containerType: childProduct.containerType,
      volume: childProduct.volume,
      packQuantity: childProduct.packQuantity,
      weight: childProduct.weight,
      ParentId: childProduct.ParentId,
      vegan: childProduct.vegan,
      new: null,
      shape: null,
      glutenFree: childProduct.glutenFree,
      lactoseFree: childProduct.lactoseFree,
      kind: fullProduct.kind,
      description: fullProduct.description,
      abv: fullProduct.abv,
      imageUrl: fullProduct.imageUrl,
      heroImageUrl: fullProduct.heroImageUrl,
      canBackorder: childProduct.canBackorder,
      stock: childProduct.stock,
      availableStock: childProduct.availableStock,
      maxOrderQuantity: childProduct.maxOrderQuantity,
      availableFrom: childProduct.availableFrom,
      ProductPriceTier: {
        PriceTierId: productPriceTier.PriceTierId,
        price: productPriceTier.price,
        discountable: productPriceTier.discountable,
      },
      Parent: parentProduct
        ? {
            id: parentProduct.id,
            name: parentProduct.name,
            glutenFree: parentProduct.glutenFree,
            lactoseFree: parentProduct.lactoseFree,
            vegan: parentProduct.vegan,
            heroImageUrl: parentProduct.heroImageUrl,
            imageUrl: parentProduct.imageUrl,
          }
        : null,
    },
  };
};

export const buildOrderItemFromMarketProduct = ({
  productId,
  fullProduct,
  quantity,
  itemId,
  promotion,
}: {
  productId: number;
  fullProduct: BuyerProductGetResponseType;
  quantity: number;
  itemId?: number;
  promotion?: {
    rewardItemId: number;
    price: number;
  } | null;
}): BasketOrderItem | null => {
  const child = fullProduct.Products.find(
    (product) => product.id === productId,
  );
  if (!child?.ProductPriceTier) return null;

  const item = buildOrderItemFromDiscoveryProduct(
    { id: child.id } as DiscoveryV2ListResponseType[number],
    fullProduct,
  );
  return item
    ? {
        ...item,
        id: itemId,
        quantity,
        ...(promotion && {
          price: promotion.price,
          fullPrice: promotion.price,
          promotionAppliedAt: new Date(),
          PromotionRewardItemId: promotion.rewardItemId,
        }),
      }
    : null;
};
